export default __webpack_public_path__ + "static/media/youtube.ae114928.svg";